(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});

  DNB.Footer = {
    init: function () {
      var backTop = document.querySelector("[data-back-top]");
      if (!backTop) return;
      backTop.addEventListener("click", function (e) {
        e.preventDefault();
        if (DNB.ScrollService) DNB.ScrollService.scrollTo(0);
        else window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  };
})(window, document);
